// Two separate ideas, deliberately kept apart:
//   - the city *filter*, an explicit choice that changes the query
//   - the city *label*, what the tagline says, which also covers the case where
//     the catalogue only holds one city and nobody has chosen anything yet
// Shared verbatim with mobile/utils/city.js, minus the storage helpers.

const FILTER_KEY = 'eventhub.city.filter';
const LABEL_KEY = 'eventhub.city.label';

export function resolveActiveCity(selectedCity, cities = []) {
  if (selectedCity) {
    return selectedCity;
  }
  return cities.length === 1 ? cities[0].value : undefined;
}

export function readStoredCityFilter() {
  try {
    return localStorage.getItem(FILTER_KEY) || undefined;
  } catch {
    return undefined;
  }
}

export function storeCityFilter(city) {
  try {
    if (city) {
      localStorage.setItem(FILTER_KEY, city);
    } else {
      localStorage.removeItem(FILTER_KEY);
    }
  } catch {
    // Persisting the choice is a convenience, not a requirement.
  }
}

// Cached so the header reads the same city on pages that never load filter options.
export function readStoredCityLabel() {
  try {
    return localStorage.getItem(LABEL_KEY) || undefined;
  } catch {
    return undefined;
  }
}

export function storeCityLabel(city) {
  try {
    if (city) {
      localStorage.setItem(LABEL_KEY, city);
    } else {
      localStorage.removeItem(LABEL_KEY);
    }
  } catch {
    // As above.
  }
}
